import { stringify } from "query-string";
import * as Cookies from "js-cookie";
import { instance } from "../instance";
import { IAxiosError } from "../interfaces";
import { getError } from "../utils";
import { operatorPortalIdTokenHeaders } from "./operatorAdminChat";
import { normalizeOperatorEmail } from "../../utils/operatorEmail";

import {
  GetLeagueListRequest, NameInput, GetCityListRequest,
  GetStadiumListRequest, GetTeamListRequest, GetSportListRequest,
} from "../../shared/interfaces";
import { PATH } from "../../shared/constants";

export const getSportListRequest = async (): Promise<GetSportListRequest[]> => {
  try {
    const response = await instance.get<GetSportListRequest[]>(`${PATH.API}/${PATH.SPORT}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getLeagueListRequest = async (request: GetLeagueListRequest): Promise<NameInput[]> => {
  const params = stringify(request);

  try {
    const response = await instance.get(`${PATH.API}/${PATH.LEAGUE}?${params}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getTeamListRequest = async (request: GetTeamListRequest): Promise<NameInput[]> => {
  const params = stringify(request);

  try {
    const response = await instance.get(`${PATH.API}/${PATH.TEAM}/${PATH.LIST}?${params}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getStateListRequest = async (): Promise<NameInput[]> => {
  try {
    const response = await instance.get(`${PATH.API}/${PATH.STATE}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getCityListRequest = async (request: GetCityListRequest): Promise<NameInput[]> => {
  const params = stringify(request);

  try {
    const response = await instance.get(`${PATH.API}/${PATH.CITY}?${params}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getStadiumListRequest = async (
  request: GetStadiumListRequest,
): Promise<NameInput[]> => {
  const params = stringify(request);

  try {
    const response = await instance.get(`${PATH.API}/${PATH.STADIUM}?${params}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

function sportDataMutationConfig() {
  const email = normalizeOperatorEmail(Cookies.get("SessionEmailAddress") || "");
  return {
    ...operatorPortalIdTokenHeaders(),
    params: email ? { email } : undefined,
  };
}

export const addSportsRequest = async (names: string): Promise<NameInput[]> => {
  try {
    const response = await instance.post(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.SPORT_DATA}/sports`,
      { names },
      sportDataMutationConfig(),
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const addLeaguesRequest = async (
  sportId: string,
  names: string,
): Promise<NameInput[]> => {
  try {
    const response = await instance.post(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.SPORT_DATA}/leagues`,
      { sport: sportId, names },
      sportDataMutationConfig(),
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const addStatesRequest = async (names: string): Promise<NameInput[]> => {
  try {
    const response = await instance.post(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.SPORT_DATA}/states`,
      { names },
      sportDataMutationConfig(),
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const addCitiesRequest = async (
  stateId: string,
  names: string,
): Promise<NameInput[]> => {
  try {
    const response = await instance.post(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.SPORT_DATA}/cities`,
      { state: stateId, names },
      sportDataMutationConfig(),
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
